// extracted by mini-css-extract-plugin
export default {"subList":"subscriptionSelection_subList__O3FTf"};